import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config.json";

const ADMIN_API_URL = config.ADMIN_API_URL;

/**
 * Every GHG database in priority order, with its source reference and factor
 * count. Silent, because the page shows its own error.
 *
 * @returns {Promise<{ isSuccess: boolean, data: { data?: import("./helpers").GhgDatabase[], error?: string } } | undefined>}
 */
export const getGhgDatabaseList = () => apiCall(`${ADMIN_API_URL}ghgDatabases`, {}, {}, "GET", { silent: true });

/**
 * Creates a GHG database, or edits database `id`. Silent, because the form
 * shows the outcome.
 *
 * @param {number|null} id
 * @param {ReturnType<typeof import("./helpers").draftToPayload>} values
 */
export const saveGhgDatabase = (id, values) =>
  id == null
    ? apiCall(`${ADMIN_API_URL}ghgDatabases`, {}, values, "POST", { silent: true })
    : apiCall(`${ADMIN_API_URL}ghgDatabases/${id}`, {}, values, "PUT", { silent: true });
